// composables/useSnackbar.js
import { ref } from "vue";

const snackbarState = ref({
  show: false,
  message: "",
  color: "info",
  timeout: 3000,
  location: "top",
  // salvia-798: referência de correlação, quando a resposta do backend traz uma.
  reference: null,
});

export function useSnackbar() {
  const showSnackbar = (
    message,
    color = "info",
    timeout = 3000,
    location = "top",
    reference = null
  ) => {
    snackbarState.value = {
      show: true,
      message,
      color,
      timeout,
      location,
      reference,
    };
  };

  const hideSnackbar = () => {
    snackbarState.value.show = false;
  };

  // Métodos de conveniência (sem emojis)
  const success = (message, timeout = 3000, location = "top") => {
    showSnackbar(message, "success", timeout, location);
  };

  const error = (message, timeout = 3000, location = "top") => {
    showSnackbar(message, "error", timeout, location);
  };

  /**
   * Erro de requisição, com a referência de correlação — salvia-798.
   *
   *     erroDeRequisicao(err, "Erro ao criar consulta")
   *
   * O identificador é anexado ao erro pelo interceptor do http.js. Quando o
   * endpoint ainda não devolve um (ou a falha nem chegou ao servidor), o toast
   * aparece igual, só sem a referência — nenhuma tela quebra por causa disso.
   *
   * O texto do erro NÃO é exibido: numa aplicação de saúde ele pode carregar
   * nome de tabela, trecho de SQL ou caminho de arquivo, e o usuário costuma
   * encaminhar o print para fora do time. A referência dá ao time o caminho
   * até a causa sem expor nada.
   */
  const erroDeRequisicao = (err, message, timeout = 8000, location = "top") => {
    showSnackbar(message, "error", timeout, location, err?.requestId ?? null);
  };

  const warning = (message, timeout = 3000, location = "top") => {
    showSnackbar(message, "warning", timeout, location);
  };

  const info = (message, timeout = 3000, location = "top") => {
    showSnackbar(message, "info", timeout, location);
  };

  return {
    snackbarState,
    showSnackbar,
    hideSnackbar,
    success,
    error,
    erroDeRequisicao,
    warning,
    info,
  };
}
